import Request from './request'

const Support = {
  getSupports(callback) {
    Request.get('support/ticket-list').then(callback).catch(this.bad_answer)
  },
  getTicketInfo(ticket_id, callback) {
    Request.get('support/ticket/'+ticket_id).then(callback).catch(this.bad_answer)
  },
  openTicket(params, callback) {
    Request.post('support/open', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  actionAnswer(params, callback) {
    Request.post('support/answer', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceTickets(dev_id, callback) {
    Request.get('support/device-tickets?device_id=' + dev_id).then(callback).catch(this.bad_answer)
  },
  supportSearch(params, callback) {
    Request.post('support/search', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  setExecutorTicket(params, callback) {
    Request.post('support/set-executor', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Support
